import * as type from '../mutation-type'
import * as manageApi from '../../api/manage.js'

const state = {
  // queue
  manageQueueList: [],
  manageQueueListTotalCount: 0,
  manageBatchTasksList: [],
  manageBatchTasksListTotalCount: 0,
  manageCollectionLogsList: [],
  manageCollectionLogsListTotalCount: 0,
  manageQueueInfo: {},
  manageQueueTasksList: [],
  manageQueueTasksListTotalCount: 0,
  manageQueueAgents: [],
  autoQueue: [],
  manageAutoQueueTasksList: 0,

  // user
  manageUserList: [],
  manageUserListTotalCount: 0,
  manageAgentInfo: {}
}

const getters = {
  // queue
  manageQueueList: state => state.manageQueueList,
  manageQueueListTotalCount: state => state.manageQueueListTotalCount,
  manageBatchTasksList: state => state.manageBatchTasksList,
  manageBatchTasksListTotalCount: state => state.manageBatchTasksListTotalCount,
  manageCollectionLogsList: state => state.manageCollectionLogsList,
  manageCollectionLogsListTotalCount: state => state.manageCollectionLogsListTotalCount,
  manageQueueInfo: state => state.manageQueueInfo,
  manageQueueTasksList: state => state.manageQueueTasksList,
  manageQueueTasksListTotalCount: state => state.manageQueueTasksListTotalCount,
  manageQueueAgents: state => state.manageQueueAgents,
  manageAutoQueue: state => state.autoQueue,
  manageAutoQueueTasksList: state => state.manageAutoQueueTasksList,

  // user
  manageUserList: state => state.manageUserList,
  manageUserListTotalCount: state => state.manageUserListTotalCount,
  manageAgentInfo: state => state.manageAgentInfo
}

const actions = {
  // queue
  fetchManageQueue({ commit }, { searchParams, page, size, queueType }) {
    manageApi.fetchManageQueue(page, size, queueType, searchParams).then(res => {
      commit(type.SET_MANAGE_QUEUE_LIST, res.data.records)
      commit(type.SET_MANAGE_QUEUE_LIST_TOTAL_COUNT, res.data.total)
    })
  },
  fetchManageBatchTasks({ commit }, { searchParams, page, size, userId, divisionType }) {
    manageApi.fetchManageBatchTasks(page, size, userId, divisionType, searchParams).then(res => {
      commit(type.SET_MANAGE_BATCH_TASKS_LIST, res.data.records)
      commit(type.SET_MANAGE_BATCH_TASKS_LIST_TOTAL_COUNT, res.data.total)
    })
  },
  fetchCollectionLogsList({ commit }, { searchParams, currentPage, pageSize, userId }) {
    manageApi.fetchCollectionLogsList(currentPage, pageSize, userId, searchParams).then(res => {
      commit(type.SET_MANAGE_COLLECTION_LOGS_LIST, res.data.records)
      commit(type.SET_MANAGE_COLLECTION_LOGS_LIST_TOTAL_COUNT, res.data.total)
    })
  },
  async getAutoQueue({ commit }, { page, size }) {
    const res = await manageApi.getAutoQueue(page, size)
    commit(type.SET_MANAGE_AUTO_QUEUE, res.data)
    commit(type.SET_MANAGE_AUTO_QUEUE_LIST_TOTAL_COUNT, res.data.total)
  },
  fetchQueueInfo({ commit }, { queueId }) {
    manageApi.fetchQueueInfo(queueId).then(res => {
      commit(type.SET_MANAGE_QUEUE_INFO, res.data)
    })
  },
  fetchQueueTasks({ commit }, { queueId, searchParams, page, size }) {
    manageApi.fetchQueueTasks(queueId, page, size, searchParams).then(res => {
      commit(type.SET_MANAGE_QUEUE_TASKS_LIST, res.data.records)
      commit(type.SET_MANAGE_QUEUE_TASKS_LIST_TOTAL_COUNT, res.data.total)
    })
  },
  fetchQueueAgents({ commit }, { queueId }) {
    manageApi.fetchQueueAgents(queueId).then(res => {
      commit(type.SET_QUEUE_AGENTS, res.data)
    })
  },

  // user
  fetchManageUserList({ commit }, { searchParams, current, size }) {
    manageApi.fetchManageUserList(current, size, searchParams).then(res => {
      commit(type.SET_MANAGE_USER_LIST, res.data.records)
      commit(type.SET_MANAGE_USER_LIST_TOTAL_COUNT, res.data.total)
    })
  },
  fetchUserInfo({ commit }, { id }) {
    return manageApi.fetchUserInfo(id).then(res => {
      commit(type.SET_MANAGE_AGENT_INFO, res.data)
    })
  }
}

const mutations = {
  // queue
  [type.SET_MANAGE_QUEUE_LIST](state, params) {
    state.manageQueueList = params
  },
  [type.SET_MANAGE_QUEUE_LIST_TOTAL_COUNT](state, totalCount) {
    state.manageQueueListTotalCount = totalCount
  },
  [type.SET_MANAGE_BATCH_TASKS_LIST](state, params) {
    state.manageBatchTasksList = params
  },
  [type.SET_MANAGE_BATCH_TASKS_LIST_TOTAL_COUNT](state, totalCount) {
    state.manageBatchTasksListTotalCount = totalCount
  },
  [type.SET_MANAGE_COLLECTION_LOGS_LIST](state, params) {
    state.manageCollectionLogsList = params
  },
  [type.SET_MANAGE_COLLECTION_LOGS_LIST_TOTAL_COUNT](state, totalCount) {
    state.manageCollectionLogsListTotalCount = totalCount
  },
  [type.SET_MANAGE_QUEUE_INFO](state, params) {
    state.manageQueueInfo = params
  },
  [type.SET_MANAGE_QUEUE_TASKS_LIST](state, params) {
    state.manageQueueTasksList = params
  },
  [type.SET_MANAGE_AUTO_QUEUE_LIST_TOTAL_COUNT](state, params) {
    state.manageAutoQueueTasksList = params
  },
  [type.SET_MANAGE_QUEUE_TASKS_LIST_TOTAL_COUNT](state, totalCount) {
    state.manageQueueTasksListTotalCount = totalCount
  },
  [type.SET_QUEUE_AGENTS](state, params) {
    state.manageQueueAgents = params
  },
  [type.SET_MANAGE_AUTO_QUEUE](state, params) {
    state.autoQueue = params
  },

  // user
  [type.SET_MANAGE_USER_LIST](state, params) {
    state.manageUserList = params
  },
  [type.SET_MANAGE_USER_LIST_TOTAL_COUNT](state, totalCount) {
    state.manageUserListTotalCount = totalCount
  },
  [type.SET_MANAGE_AGENT_INFO](state, info) {
    state.manageAgentInfo = info
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
